import ContextMenuPlugin from "rete-context-menu-plugin";
import DockPlugin from "rete-dock-plugin";
import AreaPlugin from "rete-area-plugin";
import { SkimMatrixCalc, DemandMatrixCalc, StaCalc } from "../nodes";
import { initialize as init } from "./initialize";

const createComponents = component => [
  new SkimMatrixCalc(component),
  new DemandMatrixCalc(component),
  new StaCalc(component)
];

const nodeNames = {
  SkimMatrix: "Матрица затрат",
  DemandMatrix: "Матрица корреспонденций",
  STA: "STA"
};

export default async function(container, dock, component) {
  const { editor, engine, resize, process } = await init(container, component);

  const background = document.createElement("div");
  background.classList = "modelling-editor-background";

  dock.classList.add("dock-menu");

  const components = createComponents(component);
  const myDockRender = {
    install(editor) {
      editor.on(
        "rendernode",
        ({ el, node }) =>
          (el.innerHTML = `<i class="dock-item__icon ${node.name}"></i>
          <span class="dock-item__title">${nodeNames[node.name]}</span>`)
      );
    }
  };

  editor.use(ContextMenuPlugin, {
    delay: 500,
    searchBar: false,
    rename(comp) {
      return nodeNames[comp.name];
    }
  });
  editor.use(DockPlugin, {
    container: dock,
    plugins: [myDockRender]
  });
  editor.use(AreaPlugin, { background });

  components.map(c => {
    editor.register(c);
    engine.register(c);
  });

  // await editor.fromJSON(data);

  resize();
  process();

  return { editor, engine };
}
